import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';


@Component({
	selector: 'dashboard-filters-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
	],
	templateUrl: './dashboard-filters.dialog.html',
	styleUrl: './dashboard-filters.dialog.scss',
})

export class DashboardFiltersDialog {

	public dialogRef = inject(MatDialogRef<DashboardFiltersDialog>);
	public dialogContext: DialogContext<{}> = inject(MAT_DIALOG_DATA);


	public actions: DialogAction[] = [
		{
			id: 'edit',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Edit'),
			linkType: 'no-action',
			willCloseDialog: false,
		},
		{
			id: 'delete',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Delete'),
			linkType: 'no-action',
			willCloseDialog: false,
		},
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: 'no-action',
			willCloseDialog: true,
		},
	];


}